export const en = {
  appName: "Verena LiveTask",
  loginTitle: "Sign in",
  loginHint: "Sign in to manage Verena LiveTask.",
  email: "Email",
  password: "Password",
  signIn: "Sign in",
  signOut: "Sign out",
  idleWarning: "No activity — you will be signed out in 1 minute.",
  idleLiveWarning: "No activity — you will be signed out in 1 minute. Your live session will remain active.",
  autoLoggedOut: "You were signed out automatically due to inactivity.",
  sessionExpired: "Your session expired. Please sign in again.",
  continueWorking: "Continue",
  endDraftRestored: "An unsent end-live draft from this device was restored. Review it before submitting.",
  discardEndDraft: "Discard saved draft",
  endDraftHint: "This draft stays on this device for up to 7 days. Do not clear browser data while it is needed.",
  startDraftRestored: "An unsent start-live draft from this device was restored. Review it before pressing START.",
  discardStartDraft: "Discard saved draft",
  startDraftHint: "This draft includes the selected images and stays on this device for up to 7 days.",
  users: "Users",
  platforms: "Platforms",
  products: "Products",
  settings: "Settings",
  audit: "Audit Logs",
  loading: "Loading…",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  editUser: "Edit user",
  editPlatform: "Edit platform",
  add: "Add",
  name: "Name",
  role: "Role",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  employment: "Employment",
  fullTime: "Full-time",
  partTime: "Part-time",
  admin: "Admin",
  streamer: "Streamer",
  addUser: "Add user",
  profileImage: "Profile image",
  changeProfileImage: "Change profile image",
  profileImageHint: "JPG, PNG, WebP or HEIC, up to 20 MB · automatically optimised",
  invalidProfileImage: "This image could not be processed. Choose a JPG, PNG, WebP or HEIC image up to 20 MB.",
  profileImageSaved: "Profile image saved",
  uploadingFile: "Uploading file…",
  uploadFailed: "Upload failed. Check your connection and try again.",
  myAccount: "My account",
  saveProfileImage: "Save profile image",
  changePassword: "Change password",
  currentPassword: "Current password",
  confirmNewPassword: "Confirm new password",
  changePasswordHint: "After a successful change, your other signed-in devices will be signed out.",
  passwordChanged: "Password changed successfully",
  passwordConfirmationMismatch: "The new password and confirmation do not match.",
  currentPasswordIncorrect: "The current password is incorrect.",
  newPasswordMustDiffer: "The new password must differ from the current password.",
  statusSaveFailed: "The status was not saved. Please try again.",
  pendingActivation:
    "New accounts will be activated by email in a later phase.",
  addPlatform: "Add platform",
  url: "URL",
  color: "Color",
  icon: "Icon",
  addProduct: "Add product",
  category: "Category",
  productName: "Product name",
  productLimit: "Maximum 50 active products per category.",
  rates: "Rates and targets",
  partTimeRate: "Part-time rate per hour (THB)",
  fullTimeRate: "Full-time rate per hour (THB)",
  commissionRate: "Affiliate commission (%)",
  roiGood: "Good ROI (at least)",
  roiOk: "Acceptable ROI (at least)",
  autoCloseHours: "Auto-close after (hours)",
  telegramChatIds: "Telegram chat IDs",
  settingsRatesTitle: "Costs and rates",
  settingsRoiTitle: "ROI performance thresholds",
  settingsPreviewTitle: "Calculation preview",
  settingsTelegramTitle: "Telegram notifications",
  partTimeRateHint: "Used for sessions by part-time employees, regardless of live time.",
  fullTimeRateHint: "Used for sessions by full-time employees, regardless of live time.",
  commissionRateHint: "Percentage of affiliate sales (0–100%).",
  autoCloseHoursHint: "Between 1 and 12 hours; a warning is sent 30 minutes before closing.",
  roiGoodHint: "Must be higher than the acceptable ROI threshold.",
  roiOkHint: "Results below this value are marked below target.",
  settingsPreviewScenario: "Example: 2-hour live · Verena THB 10,000 · Affiliate THB 4,000",
  settingsPreviewPartTime: "Part-time pay (2 hours)",
  settingsPreviewFullTime: "Full-time pay (2 hours)",
  settingsPreviewCommission: "Commission",
  settingsPreviewRevenue: "Net revenue",
  roiExcellent: "Good",
  roiAcceptable: "Acceptable",
  roiBelowTarget: "Below target",
  telegramChatIdsHint: "Enter one chat ID per line. Groups and users are supported. Leave blank to use the system default.",
  testTelegram: "Test Telegram",
  telegramTestSuccess: "Test message sent to {count} destination(s).",
  telegramTestFailed: "The Telegram test failed. Check the chat IDs and bot permissions.",
  telegramTestBotTokenMissing: "The V3 Worker cannot find TELEGRAM_BOT_TOKEN. Check that the secret was saved and deployed.",
  telegramTestBotTokenInvalid: "The Telegram bot token is invalid. Copy it again from BotFather without adding a bot prefix.",
  telegramTestChatNotFound: "Telegram cannot find this chat ID. Check the ID and make sure the bot has joined the chat or channel.",
  telegramTestBotForbidden: "The bot cannot send messages. Add it to the channel and allow it to post messages.",
  telegramTestRateLimited: "Telegram is temporarily rate limiting messages. Wait briefly and try again.",
  telegramTestUnavailable: "Telegram is temporarily unreachable. Please try again.",
  reset: "Reset",
  invalidRoiThresholds: "The good ROI threshold must be higher than the acceptable threshold.",
  invalidSettings: "Check the settings: hourly rates must be above 0, commission 0–100%, and auto-close 1–12 hours.",
  invalidTelegramChatIds: "Telegram chat IDs must be numeric, one per line or separated by commas.",
  confirmRecalculateCurrentMonth: "The commission rate changed. Recalculate completed sessions in the current month?\n\nPrevious months and auto-closed sessions will not be changed.",
  recalculatedSessions: "Settings saved and {count} session(s) recalculated.",
  savedWithoutRecalculation: "Settings saved without recalculating existing sessions.",
  reminders: "Pre-live reminders",
  addReminderCategory: "Add category",
  addReminderItem: "Add item",
  reminderTitle: "Category title",
  reminderItem: "Reminder item",
  reminderEditorHint:
    "Edit categories and items directly, then save the full reminder list.",
  saveReminders: "Save reminders",
  saveSuccess: "Saved successfully",
  requestFailed: "The request could not be completed",
  noData: "No data yet",
  confirmDelete: "Delete this item?",
  bootstrapEyebrow: "Phase 1 · Bootstrap",
  bootstrapTitle: "Verena LiveTask is ready for development",
  bootstrapBody:
    "The frontend, API, and database foundations are in place and remain completely isolated from V2.",
  apiLabel: "API endpoint",
  languageButton: "ภาษาไทย",
  dashboardTitle: "V3 management centre",
  dashboardHint: "This data lives in the new V3 system and does not affect V2.",
  refresh: "Refresh",
  create: "Create",
  update: "Update",
  actions: "Actions",
  enabled: "Enabled",
  disabled: "Disabled",
  createUserHint:
    "New accounts receive an activation email and remain inactive until they set a password.",
  pendingActivationStatus: "Pending",
  resendActivation: "Resend invitation",
  activationResent: "Brevo accepted the invitation email. Ask the recipient to check Inbox or Spam/Junk.",
  activationQueued: "The email is queued and will be retried automatically.",
  lastActiveAdmin: "At least one active administrator is required.",
  searchManagement: "Search name or email",
  allStatuses: "All statuses",
  allCategories: "All categories",
  confirmDeactivateProduct: "Deactivate this product? It will disappear from new live forms, but past sessions will not change.",
  confirmMoveProduct: "Move this product to another category?",
  productMoveBlocked: "The category cannot be changed while {count} streamer(s) are live: {names}. Wait until they finish.",
  platformPreview: "Preview",
  shopProfilePhoto: "Shop profile photo",
  shopProfilePhotoHint: "JPEG, PNG, or WebP · maximum 2.5 MB",
  productCategories: "Products by category",
  productStatus: "Product status",
  settingsHelp: "Settings are sensitive and visible only to administrators.",
  emptyReminders: "No reminders yet",
  addReminder: "Add reminder",
  remove: "Remove",
  unexpectedError: "An unexpected error occurred",
  live: "Live",
  recordLive: "Record Live",
  readyToLive: "Ready to Go Live",
  readyToLiveHint: "Press START when your live session begins",
  choosePlatform: "Choose Platform",
  liveUrlRequiredHint: "Required — paste the viewer-facing URL of this live session",
  issueBeforeLive: "Issue Report / Notes (before live)",
  optionalImagesHint: "Optional supporting photos · maximum 5 images",
  liveInProgress: "Session in progress",
  platform: "Platform",
  liveUrl: "Live URL",
  showcasePlan: "Planned showcase",
  actualShowcase: "Products actually showcased",
  actualShowcaseHint: "Loaded from the start form. Review and update it to match the products actually showcased before ending the live.",
  checklist: "Pre-live checklist",
  scheduledNow: "Scheduled lives around now",
  scheduledNowHint:
    "Shown for confirmation only. Please enter the live details yourself.",
  noScheduledNow: "There are no scheduled live sessions around this time.",
  substituteFor: "Streaming for another streamer",
  normalLive: "No — this is my scheduled live",
  faceHint:
    "Take a face photo to verify identity · date and time are stamped automatically",
  liveElapsed: "Live duration",
  calculationPreview: "Enter sales to preview the calculation",
  startFace: "Start face photo",
  endFace: "End face photo",
  optionalImages: "Supporting images (optional, up to 5)",
  chooseFileOrCamera: "Choose file or Open Camera",
  noFileChosen: "No file chosen",
  startLive: "START — Go live",
  endLive: "END — End live",
  closeSession: "Close session",
  closeSessionHint: "Use only when the streamer has already finished but cannot close the session. Sales are set to zero and excluded from reports until an administrator validates it.",
  actualEndTime: "Actual end time",
  editSession: "Edit session",
  validateLiveSession: "Validate live session",
  validationEditHint: "Review and correct the details below. Duration, labour cost, commission and ROI will be recalculated automatically.",
  validationSaveHint: "Save: keeps the edited data but does not change the validation status.",
  validationConfirmHint: "Validate / re-validate: saves the data and records the validator's name and time.",
  recalculationPreview: "Recalculation preview",
  validateSession: "Validate",
  revalidateSession: "Re-validate",
  validateAndEditData: "Validate and edit data",
  validatedBy: "Validated by {name} · {time}",
  verenaSales: "Verena Sales (THB)",
  affiliateSales: "Affiliate Sales (THB)",
  audience: "Audience",
  orderNumbers: "Order numbers",
  endNote: "Post-live note",
  noActiveLive: "No active session",
  liveSaved: "Live session saved",
  liveStarted: "Live started",
  sessionStartedAt: "Started at",
  dashboard: "Dashboard",
  history: "History",
  myHistory: "My history",
  startPhotos: "Start photos",
  endPhotos: "End photos",
  photo: "Photo",
  viewDetails: "View details",
  imageUnavailable: "This image could not be loaded",
  managerReport: "Manager report",
  reportPeriod: "Report period",
  generateReport: "Generate report",
  exportReport: "Export report",
  reportOf: "Manager Report of",
  year: "Year",
  performanceSummary: "Performance summary",
  audiencePerHour: "Audience per hour",
  totalAudience: "Total audience",
  total: "Total",
  managerStartFace: "Start face",
  managerEndFace: "End face",
  managerSubstituteFor: "For",
  chooseReportLanguage: "Choose report language",
  reportLanguageHint: "Numbers and data are identical in both languages.",
  printOrSavePdf: "Print / Save PDF",
  backToReport: "Back to report",
  printHelp: "Choose Print, then select Save as PDF to save the file.",
  sortAscending: "Sort ascending",
  sortDescending: "Sort descending",
  resetSorting: "Reset sorting",
  totalRevenue: "Net revenue",
  totalOt: "Total labor cost",
  laborCost: "Labor cost",
  totalHours: "Total live hours",
  sessions: "Sessions",
  revenuePerHour: "Revenue per hour",
  commission: "Commission",
  actionCenter: "Past 7 day Activity Summary",
  liveNow: "Live now",
  belowTarget7d: "ROI below target (7 days)",
  repeatedIssues7d: "Repeated issues (7 days)",
  bestPlatformWeek: "Best platform this week",
  topStreamerToday: "Top streamer today",
  fullTimeLaborCost: "Full-time labor cost",
  partTimeLaborCost: "Part-time labor cost",
  averageRevenue: "Average revenue per session",
  averageDuration: "Average duration",
  topRoiStreamer: "Top ROI streamer",
  highestRevenueHour: "Highest revenue/hour",
  bestPlatformRoi: "Best platform ROI",
  streamerEfficiency: "Streamer efficiency ranking",
  platformEfficiency: "Platform efficiency ranking",
  dailySalesRoi: "Daily sales and ROI",
  salesByStreamer: "Sales by streamer",
  roiBySlot: "ROI by time slot",
  before2200: "Before 22:00",
  after2200: "22:00 onward",
  bestLive: "Best live session",
  issueReports: "Issue reports",
  validation: "Validation",
  validated: "Validated",
  pendingValidation: "Pending validation",
  editedBy: "Edited by {name} · {time}",
  facePhotoRequired: "Take or choose a face photo, then try again.",
  validationFacePhotoRequired: "Cannot validate: both start and end face photos are required (except the end photo for an auto-closed session).",
  autoCloseActualEndRequired: "Enter the actual end time before validating an auto-closed session.",
  facePhotoUploadInvalid: "The face-photo upload could not be verified. Choose the photo and upload it again.",
  activeSession: "Live now",
  completed: "Completed",
  completedBadge: "Completed",
  date: "Date",
  month: "Month",
  applyFilters: "Apply filters",
  exportPdf: "Export PDF",
  pdfLanguageTitle: "Choose PDF Language",
  pdfLanguageHint: "Pick the language. Numbers and data are identical.",
  thaiPdf: "🇹🇭 ภาษาไทย",
  englishPdf: "🇬🇧 English",
  pdfSaveHint: "The print window will open so you can save the report as a PDF.",
  pdfPopupBlocked: "The PDF export window could not be opened. Allow pop-ups and try again.",
  time: "Time",
  duration: "Duration",
  platformPerformance: "Platform performance",
  streamerPerformance: "Streamer performance",
  issues: "Issues",
  from: "From",
  to: "To",
  allStreamers: "All streamers",
  allPlatforms: "All platforms",
  allEmployment: "All employment types",
  autoClosed: "Auto-closed",
  schedules: "Live schedules",
  mySchedule: "My schedule",
  addSchedule: "Add live schedule",
  startTime: "Start time",
  endTime: "End time",
  endsNextDay: "Ends next day (+1 day)",
  nextDayShort: "+1 day",
  hour: "Hour",
  minute: "Minute",
  confirm: "Confirm",
  timePickerHint: "Choose a time, then press Enter or double-click the minute.",
  note: "Note",
  upcomingSchedules: "Upcoming live schedules",
  noSchedules: "No live schedules",
  scheduleSubtitle: "Build and manage streamer live schedules",
  buildSchedule: "Build Schedule",
  plannedSchedules: "Planned Schedules",
  loadMonth: "Load month",
  saveSchedule: "Save schedule",
  scheduleBuildHint: "Every date starts as a day off · Add a slot to make it a work day, then save the schedule",
  selectStreamerFirst: "Please select a streamer first",
  addSlot: "Add slot",
  dayOff: "Off",
  dayOffNoLive: "Day off (no live)",
  search: "Search",
  addEntry: "Add entry",
  editSchedule: "Edit live entry",
  cancelSchedule: "Cancel entry",
  pastSchedule: "Past",
  scheduleSaved: "Schedule saved",
  invalidScheduleTime: "Check the times: use +1 day for an overnight slot.",
  auditHelp: "Read-only record of important system and administrator actions",
  auditAction: "Action",
  auditDetail: "Details",
  auditActor: "Performed by",
  auditAllActors: "All users and system",
  auditResult: "Result",
  auditSuccess: "Success",
  auditFailure: "Failed",
  auditSecurityRejected: "Security rejection",
  allActions: "All actions",
  allResults: "All results",
  previousPage: "Previous",
  nextPage: "Next",
  historyPageSummary: "Page {page} of {pages} · {total} live sessions",
  historyFilterTotals: "Totals for filtered sessions",
  totalSessions: "Total sessions",
  rowsPerPage: "Sessions per page",
  auditPageSummary: "Page {page} of {pages} · {total} records",
  forgotPassword: "Forgot password",
  forgotPasswordHint: "Enter your email to receive a password-reset link.",
  sendResetLink: "Send reset link",
  resetPassword: "Set a new password",
  newPassword: "New password",
  resetSent:
    "If this email is registered, a password-reset link has been sent. Please check your inbox and Spam folder.",
  invalidEmail: "Enter a valid email address.",
  passwordMinLength: "Password must be at least 8 characters.",
  backToSignIn: "Back to sign in",
  showPassword: "Show password",
  hidePassword: "Hide password",
  version: "Version",
  updatedOn: "Updated on",
  bangkokTime: "Bangkok Time",
  hours: "Hours",
  categoryFoodSupplement1: "Food Supplement 1",
  categoryFoodSupplement2: "Food Supplement 2",
  categoryCosmetic: "Cosmetic",
  categoryOtherBrand: "Other Brand",
} as const;
